import { useAuth } from "@/context/AuthContext";

const KEY = "daybreyk_edition";

export const getChoice = () => (localStorage.getItem(KEY) === "corporate" ? "corporate" : "student");
export const setChoice = (e) => localStorage.setItem(KEY, e);

export const applyTheme = (edition) => {
  const corp = edition === "corporate";
  document.documentElement.classList.toggle("corp", corp);
  document.documentElement.classList.toggle("dark", corp);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", corp ? "#070D1A" : "#F3F5FA");
};

export const useEdition = () => {
  const { user } = useAuth();
  const corp = (user ? user.edition : getChoice()) === "corporate";
  return { corp, w: (student, corporate) => (corp ? corporate : student) };
};

export const W = ({ s, c }) => (useEdition().corp ? c : s);
